import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import DetailThread from '../components/DetailThread';
import { asyncReceiveDetailThread, asyncClearDetailThread } from '../states/detailThread/action';

function DetailThreadPage() {
  const { threadId } = useParams();
  const {
    detailThread,
    authUser,
    comments,
    commentVotes,
    threadVotes,
  } = useSelector((states) => states);

  const dispatch = useDispatch();

  useEffect(() => {
    const updateDetailThread = async () => {
      dispatch(asyncReceiveDetailThread(threadId));
    };

    updateDetailThread();
  }, [threadId, threadVotes, commentVotes, comments, dispatch]);

  useEffect(() => {
    const clearDetailThread = async () => {
      dispatch(asyncClearDetailThread());
    };

    clearDetailThread();
  }, [threadId, dispatch]);

  if (detailThread === null) {
    return null;
  }

  return (
    <section className="detail-page">
      <DetailThread
        detailThread={detailThread}
        authUser={authUser}
      />
    </section>
  );
}

export default DetailThreadPage;
